








































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import KpiRemarksPopup from './KpiRemarksPopup.vue';

@Component({
  components: {
    KpiRemarksPopup,
  }
})
export default class KpiRemarks extends Vue {
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    createTimeRange: [],
  }
  public isShowPopup: Boolean = false; // 是否显示主目录popup
  public popupId: Number = null;
  public tableData: any[] = [];
  public loading: Boolean = true;

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
    }
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口
  public async getList() {
    this.loading = true;
    let params: any = {
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      current: this.queryForm.current,
      size: this.queryForm.size
    };

    try {
      const res = await this.nuoxiaoerService.fetchKpiRemarks(params);
      this.loading = false;
      const list = (res.records || []).map(x => {
        return {
          ...x,
          createdTime: x.createdTime ? moment(x.createdTime).format('YYYY-MM-DD HH:mm:ss') : '--',
        }
      });
      this.tableData = list;
      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;

    } catch (error) {
      this.loading = false;
      console.error('获取KPI备注列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  //删除接口
  private async handleDelete(row: any): Promise<void> {
    try {
      await this.$confirm('是否删除该信息？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });

      await this.nuoxiaoerService.deleteKpiRemark({ id: row.id });
      this.getList()
      this.$message({
        message: '删除成功',
        type: 'success'
      });
    } catch (e) {
      this.$message({
        type: 'info',
        message: '已取消删除'
      });
    }
  }

  //重置
  public reset() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      createTimeRange: [],
    };
    this.getList()
  }

  /* 打开popup */
  public handleOpenPopup(rowData:any) {
    if (!rowData) {
      console.log('新增');
      // this.popupId = rowData.id;
      this.isShowPopup = true;
    } else {
      console.log('编辑 rowData:', rowData);
      this.popupId = rowData.id;
      this.isShowPopup = true;
    }
  }

  /* 保存后 */
  public handleAfterSaved() {
    console.log('handleAfterSaved');
    this.getList();
    this.isShowPopup = false;
    this.popupId = null;
  }

  /* 取消popup */
  public handleCancelPopup() {
    this.isShowPopup = false;
    this.popupId = null;
  }

   /* 关闭popup后 */
  public handleAfterClosePopup() {
    this.popupId = null;
  }


}
